import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';

export const procedureGenerateRoute: RouteConfig = {
  path: 'generate',
  name: 'procedureGenerate',
  component: () =>
    import(/* webpackChunkName: "ProcedureGenerate" */ '@/views/mainRoute/procedure/details/Generate.vue'),
  meta: { breadcrumb: { title: 'Generowanie dokumentacji' } },
  beforeEnter: (to, from, next) => {
    if (!store.state.setting.settings[PublicSettings.PROCEDURE_VIEW_IDS]) {
      store.dispatch('notifyError', { title: Errors.VIEW_CANNOT_LIST });
    }
    const ids = JSON.parse(store.state.setting.settings[PublicSettings.PROCEDURE_VIEW_IDS].value);
    store
      .dispatch('view/listByIds', ids)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.VIEW_CANNOT_LIST }));
  }
};
